import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { QueryOfPefAnalysisSet } from "webportalclient";
import { ODataParams, Query } from "../../Components/Query";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { OverreadStatusIdEnum } from "../../misc/api/apiTypes";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";
import PefAnalysisSetListTable from "./AnalysisSetList/PefAnalysisSetListTable";
import { PefAnalysisScreen } from "./PefAnalysisScreen";

export const PefRoot = () => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const refreshPefAnalysisSets = async (params: ODataParams): Promise<QueryOfPefAnalysisSet> => {
        let filter = params.filter ? `(${params.filter}) and ` : '';

        filter += `session/visit/subject/site/studyId eq ${study.id}`;

        return await client.client.getPefAnalysisSets(undefined, filter, params.orderby, 'session($expand=visit($select=name,subject;$expand=subject($select=id,number,site;$expand=site($select=number,studyId))))', params.top, params.skip, undefined, true);
    }

    return (
        <Switch>
            <Route path="/Pef/Analysis" exact>
                <Query onRefresh={refreshPefAnalysisSets}
                    initialFilters={[
                        { field: "status", condition: "eq", values: [OverreadStatusIdEnum.Pending, OverreadStatusIdEnum.NotStarted] },
                    ]}
                    initialOrdering={[{ field: "created", condition: "asc" }]}
                >
                    <PefAnalysisSetListTable />
                </Query>
            </Route>
            <Route path="/Pef/Analysis/:analysisSetId/:viewState" component={PefAnalysisScreen} />
        </Switch>
    );
}
